<!--<button (click)="log()">log </button>-->

<div
    [ngClass]="{ 'middle-layer-for-page-disable': showAddJobTitle }"
    (click)="showAddJobTitle = false"
></div>

<app-add-job-title-mapping-dialog
    *ngIf="showAddJobTitle"
    [clientStaffPositions]="clientStaffPositions"
    (saveSuccessful)="newJobTitleHandler($event)"
    (closeClicked)="showAddJobTitle = false"
>
</app-add-job-title-mapping-dialog>

<mat-card class="settingsBody matCardSetting">
    <form [formGroup]="employeeForm" (ngSubmit)="onSubmit()">
        <div style="width: 100%; display: table">
            <div style="width: 100% !important" *ngIf="addEditOrViewOnly === 'add'">
                <div
                    class="settings-heading"
                    style="
                        padding-left: 12px;
                        padding-top: 12px;
                        padding-bottom: 0px;
                        border-right: 1px solid #cdcdcd;
                    "
                >
                    Add New Employee
                </div>
            </div>
            <div style="display: table-row">
                <div
                    class="recordView"
                    [ngClass]="{
                        'box-shadow-bottom-right': addEditOrViewOnly !== 'add'
                    }"
                    style="display: table-cell; width: auto"
                    *ngIf="selectedEmployee"
                >
                    <div
                        id="recordViewAvatarDiv"
                        style="width: 344px !important"
                        *ngIf="addEditOrViewOnly !== 'add'"
                    >
                        <div style="width: 344px; height: 40px">
                            <button
                                mat-icon-button
                                [matMenuTriggerFor]="menu"
                                aria-label="Example icon-button with a menu"
                                *ngIf="!userProfileView"
                                (click)="$event.preventDefault()"
                                style="float: right"
                            >
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item (click)="mailto(selectedEmployee.loginEmail)">
                                    <mat-icon>email</mat-icon>
                                    <span>Email Employee</span>
                                </button>
                                <button
                                    mat-menu-item
                                    (click)="editing = true; addEditOrViewOnly = 'edit'"
                                >
                                    <mat-icon>edit</mat-icon>
                                    <span>Edit Record</span>
                                </button>
                            </mat-menu>

                            <button
                                mat-icon-button
                                [matMenuTriggerFor]="menu2"
                                aria-label="Example icon-button with a menu"
                                *ngIf="userProfileView"
                                (click)="$event.preventDefault()"
                                style="float: right"
                            >
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu2="matMenu">
                                <button mat-menu-item (click)="editSimpleContact()">
                                    <mat-icon>edit</mat-icon>
                                    <span>Edit Record</span>
                                </button>
                            </mat-menu>
                        </div>
                        <div style="margin-top: 16px">
                            {{ selectedEmployee.firstName }}&nbsp;{{ selectedEmployee.lastName }}
                        </div>
                        <div style="margin-top: 4px; font-size: 0.8em">
                            {{ selectedEmployee.jobTitle }}
                        </div>
                        <div style="margin-top: 4px; margin-bottom: 16px">
                            <a href="mailto: {{ selectedEmployee.loginEmail }}">{{
                                selectedEmployee.loginEmail
                            }}</a>
                        </div>
                    </div>
                    <div id="recordViewEmployeeProperties" formGroupName="contactInformation">
                        <div class="recordView-header">Contact Information</div>
                        <div class="recordView-label">First Name</div>
                        <div class="recordView-value" *ngIf="!editing">
                            {{ selectedEmployee.firstName }}
                        </div>
                        <div class="recordView-input-div" *ngIf="editing && employeeForm">
                            <input
                                type="text"
                                [ngClass]="{
                                    'recordView-input': true,
                                    'input-text-error': firstName.errors
                                }"
                                formControlName="firstName"
                                maxlength="25"
                            />
                        </div>
                        <div *ngIf="editing && firstName.errors" class="errors">
                            <ul class="error-list">
                                <li *ngIf="firstName.errors.required">* Required</li>
                            </ul>
                        </div>
                        <div class="recordView-label">Last Name</div>
                        <div class="recordView-value" *ngIf="!editing">
                            {{ selectedEmployee.lastName }}
                        </div>
                        <div class="recordView-input-div" *ngIf="editing">
                            <input
                                type="text"
                                [ngClass]="{
                                    'recordView-input': true,
                                    'input-text-error': lastName.errors
                                }"
                                formControlName="lastName"
                                maxlength="25"
                            />
                        </div>
                        <div *ngIf="editing && lastName.errors" class="errors">
                            <ul class="error-list">
                                <li *ngIf="lastName.errors.required">* Required</li>
                            </ul>
                        </div>
                        <div class="recordView-label">Preferred Name</div>
                        <div class="recordView-value" *ngIf="!editing">
                            {{ selectedEmployee.firstNameProper }}
                        </div>
                        <div class="recordView-input-div" *ngIf="editing">
                            <input
                                type="text"
                                [ngClass]="{
                                    'recordView-input': true,
                                    'input-text-error': preferredName.errors
                                }"
                                formControlName="preferredName"
                                maxlength="25"
                            />
                        </div>
                        <div *ngIf="editing && preferredName.errors" class="errors">
                            <ul class="error-list">
                                <li *ngIf="preferredName.errors.required">* Required</li>
                            </ul>
                        </div>
                        <div class="recordView-label">Primary Email</div>
                        <div
                            class="recordView-value"
                            *ngIf="!editing || addEditOrViewOnly == 'nonPowerUserEdit'"
                        >
                            {{ selectedEmployee.loginEmail }}
                        </div>
                        <div
                            class="recordView-input-div"
                            *ngIf="editing && addEditOrViewOnly != 'nonPowerUserEdit'"
                        >
                            <input
                                type="text"
                                [ngClass]="{
                                    'recordView-input': true,
                                    'input-text-error': primaryEmail.errors
                                }"
                                formControlName="primaryEmail"
                                (blur)="employeeEmailChangeHandler()"
                                maxlength="100"
                            />
                        </div>
                        <div *ngIf="editing && primaryEmail.errors" class="errors">
                            <ul class="error-list">
                                <li *ngIf="primaryEmail.errors.required">* Required</li>
                                <li
                                    *ngIf="
                                        primaryEmail.errors.email && !primaryEmail.errors.required
                                    "
                                >
                                    * {{ primaryEmail.value }} is not a valid email.
                                </li>
                                <li *ngIf="primaryEmail.errors.notUnique">
                                    * {{ primaryEmail.value }} is already in use. Please try a
                                    different value.
                                </li>
                                <li *ngIf="primaryEmail.errors.noDomain">
                                    * {{ primaryEmail.value }} does not have valid domain.
                                </li>
                            </ul>
                        </div>

                        <div class="recordView-label">Mobile Phone</div>
                        <div class="recordView-value" *ngIf="!editing">
                            {{ selectedEmployee.mobilePhone | mask : '(000) 000-0000' }}
                        </div>
                        <div class="recordView-input-div" *ngIf="editing">
                            <input
                                type="text"
                                mask="(000) 000-0000"
                                [ngClass]="{
                                    'recordView-input': true,
                                    'input-text-error': mobilePhone.errors
                                }"
                                formControlName="mobilePhone"
                                (blur)="employeeEmailChangeHandler()"
                                maxlength="14"
                            />
                        </div>
                        <div *ngIf="editing && mobilePhone.errors" class="errors">
                            <ul class="error-list">
                                <li *ngIf="mobilePhone.errors.required">* Required</li>
                                <li *ngIf="mobilePhone.errors.minlength">
                                    * Phone number must be 10 digits.
                                </li>
                                <li *ngIf="mobilePhone.errors.maxlength">
                                    * Phone number must be 10 digits.
                                </li>
                            </ul>
                        </div>
                        <div class="recordView-label" style="float: left">Job Title</div>
                        <div
                            class="recordView-label"
                            style="text-align: right; float: right; padding-right: 8px"
                        >
                            &nbsp;&nbsp;
                            <span
                                style="color: firebrick; cursor: pointer"
                                *ngIf="
                                    editing &&
                                    addEditOrViewOnly !== 'viewOnly' &&
                                    addEditOrViewOnly != 'nonPowerUserEdit'
                                "
                                (click)="showAddJobTitle = true"
                                >Add New</span
                            >
                        </div>
                        <div
                            class="recordView-value"
                            *ngIf="!editing || addEditOrViewOnly == 'nonPowerUserEdit'"
                            style="clear: left"
                        >
                            {{ selectedEmployee.jobTitle }}
                        </div>
                        <div
                            class="recordView-input-div"
                            *ngIf="editing && addEditOrViewOnly != 'nonPowerUserEdit'"
                        >
                            <select
                                [ngClass]="{
                                    'recordView-input-ddl': true,
                                    'input-text-error': jobTitle.errors
                                }"
                                formControlName="jobTitle"
                                style="width: 338px"
                            >
                                <option
                                    *ngFor="let clientStaffPosition of clientStaffPositions"
                                    [value]="clientStaffPosition.clientPosition"
                                >
                                    {{ clientStaffPosition.clientPosition }}
                                </option>
                            </select>
                        </div>
                        <div
                            *ngIf="editing && jobTitle.errors"
                            class="errors"
                            style="position: relative; top: 14px"
                        >
                            <ul class="error-list">
                                <li *ngIf="jobTitle.errors.required">* Required</li>
                            </ul>
                        </div>
                        <div class="recordView-label" style="margin-top: 14px; clear: left">
                            Location
                        </div>
                        <div
                            class="recordView-value"
                            *ngIf="!editing || addEditOrViewOnly == 'nonPowerUserEdit'"
                        >
                            {{ selectedEmployee.location }}
                        </div>
                        <div
                            class="recordView-input-div"
                            *ngIf="editing && addEditOrViewOnly != 'nonPowerUserEdit'"
                        >
                            <select
                                [ngClass]="{
                                    'recordView-input-ddl': true,
                                    'input-text-error': locationIdentifier.errors
                                }"
                                formControlName="locationIdentifier"
                                style="width: 338px"
                            >
                                <option
                                    *ngFor="let hierarchy of hierarchies"
                                    [value]="hierarchy.hierarchyIdentifier"
                                >
                                    {{ hierarchy.name }}
                                </option>
                            </select>
                        </div>
                        <div
                            *ngIf="
                                locationIdentifier.errors &&
                                addEditOrViewOnly !== 'viewOnly' &&
                                addEditOrViewOnly != 'nonPowerUserEdit'
                            "
                            class="errors"
                        >
                            <ul class="error-list">
                                <li *ngIf="editing && locationIdentifier.errors.required">
                                    * Required
                                </li>
                            </ul>
                        </div>
                        <div class="recordView-label">Is Supervisor?</div>
                        <div
                            class="recordView-value"
                            *ngIf="!editing || addEditOrViewOnly == 'nonPowerUserEdit'"
                        >
                            {{
                                !selectedEmployee.isSupervisor
                                    ? 'Unknown'
                                    : selectedEmployee.isSupervisor
                            }}
                        </div>
                        <div
                            class="recordView-input-div"
                            *ngIf="editing && addEditOrViewOnly != 'nonPowerUserEdit'"
                        >
                            <select
                                [ngClass]="{
                                    'recordView-input-ddl': true,
                                    'input-text-error': isSupervisor.errors
                                }"
                                formControlName="isSupervisor"
                                style="width: 338px"
                            >
                                <option
                                    *ngFor="let val of ['Unknown', 'True', 'False']"
                                    [value]="val"
                                >
                                    {{ val }}
                                </option>
                            </select>
                        </div>
                        <div *ngIf="editing && isSupervisor.errors" class="errors">
                            <ul class="error-list">
                                <li *ngIf="isSupervisor.errors.required">* Required</li>
                            </ul>
                        </div>
                        <div class="recordView-label">Reports To</div>
                        <div
                            class="recordView-value"
                            *ngIf="!editing || addEditOrViewOnly == 'nonPowerUserEdit'"
                        >
                            {{ supervisorLFName ? supervisorLFName : 'N/A' }}
                        </div>
                        <div
                            class="recordView-input-div"
                            *ngIf="editing && addEditOrViewOnly != 'nonPowerUserEdit'"
                        >
                            <select
                                [ngClass]="{
                                    'recordView-input-ddl': true,
                                    'input-text-error': supervisorIdentifier.errors
                                }"
                                *ngIf="supervisors && supervisors.length > 0; else NoSupervisors"
                                formControlName="supervisorIdentifier"
                                style="width: 338px"
                            >
                                <option [valu]="null" selected>N/A</option>
                                <option
                                    *ngFor="let supervisor of supervisors"
                                    [value]="supervisor.primaryIdentifier"
                                >
                                    {{ supervisor.lfName }}
                                </option>
                            </select>
                            <ng-template #NoSupervisors> .</ng-template>
                        </div>
                        <div *ngIf="editing && supervisorIdentifier.errors" class="errors">
                            <ul class="error-list">
                                <li *ngIf="supervisorIdentifier.errors.required">* Required</li>
                            </ul>
                        </div>
                        <div class="recordView-label">City</div>
                        <div
                            class="recordView-value"
                            *ngIf="!editing || addEditOrViewOnly == 'nonPowerUserEdit'"
                        >
                            {{ selectedEmployee.city }}
                        </div>
                        <div
                            class="recordView-input-div"
                            *ngIf="editing && addEditOrViewOnly != 'nonPowerUserEdit'"
                        >
                            <input
                                type="text"
                                [ngClass]="{
                                    'recordView-input': true,
                                    'input-text-error': city.errors
                                }"
                                formControlName="city"
                                maxlength="75"
                            />
                        </div>
                        <div *ngIf="editing && city.errors" class="errors">
                            <ul class="error-list">
                                <li *ngIf="city.errors.required">* Required</li>
                            </ul>
                        </div>
                        <div class="recordView-label">State</div>
                        <div
                            class="recordView-value"
                            *ngIf="!editing || addEditOrViewOnly == 'nonPowerUserEdit'"
                        >
                            {{ selectedEmployee.state }}
                        </div>
                        <div
                            class="recordView-input-div"
                            *ngIf="editing && addEditOrViewOnly != 'nonPowerUserEdit'"
                        >
                            <select
                                [ngClass]="{
                                    'recordView-input-ddl': true,
                                    'input-text-error': state.errors
                                }"
                                formControlName="state"
                                style="width: 338px"
                            >
                                <option *ngFor="let state of states" [value]="state.abbreviation">
                                    {{ state.name }}
                                </option>
                            </select>
                        </div>
                        <div *ngIf="editing && state.errors" class="errors">
                            <ul class="error-list">
                                <li *ngIf="state.errors.required">* Required</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div
                    style="width: 100%; display: table-cell; margin-top: 0px"
                    *ngIf="selectedEmployee"
                >
                    <div id="employeeDetails" formGroupName="employeeDetails">
                        <div class="details-heading">
                            <i
                                class="fas fa-caret-down"
                                *ngIf="employeeDetailsExpanded"
                                (click)="employeeDetailsExpanded = !employeeDetailsExpanded"
                            ></i>
                            <i
                                class="fas fa-caret-up"
                                *ngIf="!employeeDetailsExpanded"
                                (click)="employeeDetailsExpanded = !employeeDetailsExpanded"
                            ></i>
                            <span> Employee Details </span>
                        </div>
                        <div
                            *ngIf="employeeDetailsExpanded"
                            class="recordView-label"
                            style="padding-left: 16px"
                        >
                            Employment Status
                        </div>
                        <div
                            *ngIf="employeeDetailsExpanded"
                            class="recordView-value"
                            style="padding-left: 16px"
                        >
                            {{ employeeStatus.value }}
                        </div>
                        <div
                            *ngIf="employeeDetailsExpanded"
                            class="recordView-label"
                            style="padding-left: 16px"
                        >
                            On Leave
                        </div>
                        <div
                            *ngIf="
                                employeeDetailsExpanded &&
                                (!editing || addEditOrViewOnly == 'nonPowerUserEdit')
                            "
                            class="recordView-value"
                            style="padding-left: 16px"
                        >
                            {{ selectedEmployee.onLeave ? 'Yes' : 'No' }}
                        </div>
                        <div
                            class="recordView-input-div"
                            *ngIf="
                                employeeDetailsExpanded &&
                                editing &&
                                addEditOrViewOnly != 'nonPowerUserEdit'
                            "
                            style="padding-left: 16px"
                        >
                            <input type="radio" formControlName="onLeave" value="true" />Yes
                            <input type="radio" formControlName="onLeave" value="false" />No
                        </div>
                        <div *ngIf="editing && onLeave.errors" class="errors">
                            <ul class="error-list" style="padding-left: 16px">
                                <li *ngIf="onLeave.errors.required">* Required</li>
                            </ul>
                        </div>
                        <div
                            *ngIf="employeeDetailsExpanded"
                            class="recordView-label"
                            style="padding-left: 16px"
                        >
                            Hire Date
                        </div>
                        <div
                            *ngIf="
                                employeeDetailsExpanded &&
                                (!editing || addEditOrViewOnly == 'nonPowerUserEdit')
                            "
                            class="recordView-value"
                            style="padding-left: 16px"
                        >
                            {{ selectedEmployee.hireDate | date : 'MM/dd/yyyy' : 'UTC' }}
                        </div>
                        <div
                            class="recordView-input-div"
                            *ngIf="
                                employeeDetailsExpanded &&
                                editing &&
                                addEditOrViewOnly != 'nonPowerUserEdit'
                            "
                            style="padding-left: 16px"
                        >
                            <kendo-datepicker
                                [ngClass]="{
                                    'recordView-input-date': true,
                                    'input-text-error': hireDate.errors
                                }"
                                format="MM/dd/yyyy"
                                formControlName="hireDate"
                            ></kendo-datepicker>
                        </div>
                        <div *ngIf="editing && hireDate.errors" class="errors">
                            <ul class="error-list" style="padding-left: 16px">
                                <li *ngIf="hireDate.errors.required">* Required</li>
                            </ul>
                        </div>
                        <div
                            *ngIf="employeeDetailsExpanded"
                            class="recordView-label"
                            style="padding-left: 16px"
                        >
                            Termination Date
                        </div>
                        <div
                            *ngIf="
                                employeeDetailsExpanded &&
                                (!editing || addEditOrViewOnly == 'nonPowerUserEdit')
                            "
                            class="recordView-value"
                            style="padding-left: 16px"
                        >
                            {{
                                selectedEmployee.terminationDate
                                    ? (selectedEmployee.terminationDate | date : 'MM/dd/yyy')
                                    : 'N/A'
                            }}
                        </div>
                        <div
                            class="recordView-input-div"
                            *ngIf="
                                employeeDetailsExpanded &&
                                editing &&
                                addEditOrViewOnly != 'nonPowerUserEdit'
                            "
                            style="padding-left: 16px"
                        >
                            <kendo-datepicker
                                [ngClass]="{
                                    'recordView-input-date': true,
                                    'input-text-error': terminationDate.errors
                                }"
                                format="MM/dd/yyyy"
                                formControlName="terminationDate"
                            ></kendo-datepicker>
                        </div>
                        <div *ngIf="editing && terminationDate.errors" class="errors">
                            <ul class="error-list">
                                <li *ngIf="terminationDate.errors.required">* Required</li>
                            </ul>
                        </div>
                        <div
                            *ngIf="employeeDetailsExpanded"
                            class="recordView-label"
                            style="padding-left: 16px"
                        >
                            Employment Type
                        </div>
                        <div
                            *ngIf="
                                employeeDetailsExpanded &&
                                (!editing || addEditOrViewOnly == 'nonPowerUserEdit')
                            "
                            class="recordView-value"
                            style="padding-left: 16px"
                        >
                            {{ selectedEmployee.fullTime ? 'Full-time' : 'Part-time' }}
                        </div>
                        <div
                            class="recordView-input-div"
                            *ngIf="
                                employeeDetailsExpanded &&
                                editing &&
                                addEditOrViewOnly != 'nonPowerUserEdit'
                            "
                            style="padding-left: 16px"
                        >
                            <select
                                [ngClass]="{
                                    'recordView-input-ddl': true,
                                    'input-text-error': employmentType.errors
                                }"
                                formControlName="employmentType"
                                style="width: 338px"
                            >
                                <option
                                    *ngFor="let type of ['Full-Time', 'Part-Time']"
                                    [value]="type"
                                >
                                    {{ type }}
                                </option>
                            </select>
                        </div>
                        <div *ngIf="editing && employmentType.errors" class="errors">
                            <ul class="error-list">
                                <li *ngIf="employmentType.errors.required">* Required</li>
                            </ul>
                        </div>
                        <div
                            *ngIf="employeeDetailsExpanded"
                            class="recordView-label"
                            style="padding-left: 16px"
                        >
                            Length of Employment
                        </div>
                        <div
                            *ngIf="employeeDetailsExpanded"
                            class="recordView-value"
                            style="padding-left: 16px"
                        >
                            {{ selectedEmployee.lengthOfEmployment }}
                        </div>
                    </div>
                    <div id="identityDetails">
                        <div class="details-heading">
                            <i
                                class="fas fa-caret-down"
                                *ngIf="identityDetailsExpanded"
                                (click)="identityDetailsExpanded = !identityDetailsExpanded"
                            ></i>
                            <i
                                class="fas fa-caret-up"
                                *ngIf="!identityDetailsExpanded"
                                (click)="identityDetailsExpanded = !identityDetailsExpanded"
                            ></i>
                            <span> Employee Identities </span>
                        </div>
                        <div *ngIf="identityDetailsExpanded" style="padding-left: 16px">
                            <table id="identityTable" style="margin: 8px 0px 16px 0px">
                                <thead>
                                    <tr>
                                        <th class="id-header-cell">Employee Number</th>
                                        <th class="id-header-cell">Type</th>
                                        <th class="id-header-cell">Description</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container
                                        formArrayName="employeeIdentifierDetails"
                                        *ngFor="let identityGroup of identities; let i = index"
                                    >
                                        <tr [formGroupName]="i">
                                            <td
                                                class="id-value-cell"
                                                *ngIf="
                                                    identityGroup.controls.clientIntegrationSource
                                                        .value === 'NMLS' && !editing;
                                                    else notNMLS
                                                "
                                            >
                                                <span *ngIf="!editing">
                                                    <a
                                                        style="text-decoration: none"
                                                        href="https://www.nmlsconsumeraccess.org/EntityDetails.aspx/INDIVIDUAL/{{
                                                            identityGroup.controls.identifier.value
                                                        }}"
                                                        target="_blank"
                                                    >
                                                        {{
                                                            identityGroup.controls.identifier.value
                                                        }}
                                                    </a>
                                                </span>
                                            </td>
                                            <ng-template #notNMLS>
                                                <td class="id-value-cell">
                                                    <span *ngIf="!editing">
                                                        {{
                                                            identityGroup.controls.identifier.value
                                                        }}
                                                    </span>
                                                    <span
                                                        *ngIf="
                                                            editing &&
                                                            addEditOrViewOnly != 'nonPowerUserEdit'
                                                        "
                                                    >
                                                        <input
                                                            formControlName="identifier"
                                                            class="identity-input"
                                                            (blur)="
                                                                employeeIdentifierChangeHandler(i)
                                                            "
                                                            (click)="
                                                                employeeIdentifierChangeWarning(i)
                                                            "
                                                            maxlength="20"
                                                        />
                                                    </span>
                                                </td>
                                            </ng-template>
                                            <td class="id-value-cell">
                                                {{ identityGroup.controls.identifierType.value }}
                                            </td>
                                            <td class="id-value-cell" style="max-width: 225px">
                                                {{ identityGroup.controls.description.value }}
                                            </td>
                                            <td class="id-value-cell">
                                                <!--put back after lg-3378 is done(https://lbaware.atlassian.net/browse/LG-3378?atlOrigin=eyJpIjoiNTNjNGQwMzBiMGE5NDg4ZTk0YjVkOTgwZGI5ZmIyYTYiLCJwIjoiamlyYS1zbGFjay1pbnQifQ)
                                {{
                                identityGroup.controls.isPrimary.value
                                    ? 'Primary'
                                    : ''
                                }}
                                -->
                                                {{
                                                    identityGroup.controls.isPrimary.value ? '' : ''
                                                }}
                                            </td>
                                        </tr>
                                        <ng-container
                                            *ngIf="
                                                editing && identities[i].get('identifier').errors
                                            "
                                        >
                                            <tr
                                                *ngIf="
                                                    identities[i].get('identifier').errors.required
                                                "
                                            >
                                                <td class="errors" colspan="4">* Required</td>
                                            </tr>
                                            <tr
                                                *ngIf="
                                                    identities[i].get('identifier').errors.notUnique
                                                "
                                            >
                                                <td class="errors" colspan="4">
                                                    *
                                                    {{ identities[i].get('identifier').value }}
                                                    is already in use. Please try a different value.
                                                </td>
                                            </tr>
                                            <tr
                                                *ngIf="
                                                    identities[i].get('identifier').errors
                                                        .zeroPaddingRequired
                                                "
                                            >
                                                <td class="errors" colspan="4">
                                                    * Identifier must be padded to at least
                                                    {{ zeroPaddingLength }} characters.
                                                </td>
                                            </tr>
                                        </ng-container>
                                    </ng-container>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div id="userDetails" formGroupName="userDetails">
                        <div class="details-heading">
                            <i
                                class="fas fa-caret-down"
                                *ngIf="userDetailsExpanded"
                                (click)="userDetailsExpanded = !userDetailsExpanded"
                            ></i>
                            <i
                                class="fas fa-caret-up"
                                *ngIf="!userDetailsExpanded"
                                (click)="userDetailsExpanded = !userDetailsExpanded"
                            ></i>
                            <span> User Details </span>
                        </div>
                        <div
                            *ngIf="userDetailsExpanded"
                            class="recordView-label"
                            style="padding-left: 16px"
                        >
                            User
                        </div>
                        <div
                            *ngIf="userDetailsExpanded"
                            class="recordView-value"
                            style="padding-left: 16px"
                        >
                            {{ selectedEmployee.userGUID ? 'Yes' : 'No' }}
                        </div>
                        <div *ngIf="selectedEmployee.userGUID">
                            <div
                                *ngIf="userDetailsExpanded"
                                class="recordView-label"
                                style="padding-left: 16px"
                            >
                                User Status
                            </div>
                            <div
                                *ngIf="
                                    userDetailsExpanded &&
                                    (!editing || addEditOrViewOnly == 'nonPowerUserEdit')
                                "
                                class="recordView-value"
                                style="padding-left: 16px"
                            >
                                {{ selectedEmployee.userStatus }}
                            </div>
                            <div
                                class="recordView-input-div"
                                *ngIf="
                                    employeeDetailsExpanded &&
                                    editing &&
                                    addEditOrViewOnly != 'nonPowerUserEdit'
                                "
                                style="padding-left: 16px"
                            >
                                <select
                                    [ngClass]="{
                                        'recordView-input-ddl': true,
                                        'input-text-error': userStatus.errors
                                    }"
                                    formControlName="userStatus"
                                >
                                    <option
                                        *ngFor="let status of ['Active', 'Inactive']"
                                        [value]="status"
                                    >
                                        {{ status }}
                                    </option>
                                </select>
                            </div>
                            <div
                                *ngIf="userDetailsExpanded"
                                class="recordView-label"
                                style="padding-left: 16px"
                            >
                                Create Date
                            </div>
                            <div
                                *ngIf="userDetailsExpanded"
                                class="recordView-value"
                                style="padding-left: 16px"
                            >
                                {{ selectedEmployee.createDate | date : 'MM/dd/yyy' }}
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="editing && addEditOrViewOnly != 'nonPowerUserEdit'"
                        style="
                            text-align: left;
                            padding-left: 200px;
                            padding-top: 24px;
                            padding-bottom: 24px;
                        "
                    >
                        <button
                            mat-raised-button
                            type="button"
                            (click)="cancelClicked()"
                            style="margin-right: 16px"
                        >
                            CANCEL
                        </button>
                        <button
                            mat-raised-button
                            primary
                            [disabled]="
                                !employeeForm.valid ||
                                employeeForm.pristine ||
                                checkingIDForUniqueness ||
                                checkingEmailForUniqueness
                            "
                            type="submit"
                        >
                            SAVE
                            <i class="fa fa-spinner fa-spin" *ngIf="loading"></i>
                        </button>
                    </div>

                    <div
                        *ngIf="editing && addEditOrViewOnly == 'nonPowerUserEdit'"
                        style="
                            text-align: left;
                            padding-left: 200px;
                            padding-top: 24px;
                            padding-bottom: 24px;
                        "
                    >
                        <button
                            mat-raised-button
                            type="button"
                            (click)="reloadComponentOnEditAndSave()"
                            style="margin-right: 16px"
                        >
                            CANCEL
                        </button>
                        <button
                            mat-raised-button
                            primary
                            type="button"
                            [disabled]="!canSubmitNonPowerUserEdit()"
                            (click)="submitNonPowerUserEdit()"
                        >
                            SAVE
                            <i class="fa fa-spinner fa-spin" *ngIf="loading"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div style="padding: 24px" *ngIf="isLBAUser">
        System Users do not have employee records. You must view as a user from one of our clients
        to see their information.
    </div>
</mat-card>
